import { ContainerEnvironment } from '@fluidx/office-fluid-types';
import { DBSchema, IDBPDatabase, openDB } from 'idb';
import { IVersionedFluidBrowserPackage } from './types';

const FluidCodeLoaderCacheDBName = 'fluidCodeLoaderCache';
export const FluidCodeLoaderObjectStoreName = 'codeLoaderStorage';

export function getCodeLoaderCache(): Promise<IDBPDatabase<FluidCodeLoaderCacheDBSchema>> {
  return openDB<FluidCodeLoaderCacheDBSchema>(FluidCodeLoaderCacheDBName, 1 /** version */, {
    async upgrade(db, _oldVersion) {
      const cacheObjectStore = db.createObjectStore(FluidCodeLoaderObjectStoreName);
      cacheObjectStore.createIndex('lastUpdatedTime', 'lastUpdatedTime');
    },
    blocked: () => {
      throw new Error(
        'Could not open code loader cache DB since it is blocked by an older client that has the DB open'
      );
    }
  });
}

/**
 * Gets the cache key for a container in the code loader cache
 */
export function getCodeLoaderCacheKey(arg: { packageName: string; containerEnvironment: ContainerEnvironment }) {
  return `${arg.packageName}_${arg.containerEnvironment}`;
}

export interface FluidCodeLoaderCacheDBSchema extends DBSchema {
  [FluidCodeLoaderObjectStoreName]: {
    /** A unique identifier for this entry, it should be the name of the package and the environment separated by an underscore*/
    key: string;

    value: {
      /** The package field from the fluid code details */
      codeDetailsPackage: IVersionedFluidBrowserPackage;

      /** The time when the codeDetails were last updated for this entry */
      lastUpdatedTime: number;
    };

    indexes: { lastUpdatedTime: number };
  };
}
